import CodeMirror from "codemirror";

// Based on http://codemirror.net/addon/mode/overlay.js
// Licensed under MIT
CodeMirror.createOverlayMode = function(base, overlay) {
  return {
    startState: function() {
      return {
        base: CodeMirror.startState(base),
        overlay: CodeMirror.startState(overlay),
        basePos: 0,
        baseCur: null,
        overlayPos: 0,
        overlayCur: null,
        streamSeen: null,
      };
    },

    copyState: function(state) {
      return {
        base: CodeMirror.copyState(base, state.base),
        overlay: CodeMirror.copyState(overlay, state.overlay),
        basePos: state.basePos,
        baseCur: null,
        overlayPos: state.overlayPos,
        overlayCur: null,
      };
    },

    token: function(stream, state) {
      // If the stream changes or the start jumps forward, reset the tokenisation.
      if (
        stream != state.streamSeen ||
        Math.min(state.basePos, state.overlayPos) < stream.start
      ) {
        state.streamSeen = stream;
        state.basePos = state.overlayPos = stream.start;
      }

      if (stream.start === state.overlayPos) {
        if (typeof overlay.token === "function") {
          // Apply the overlay tokenisation first.
          state.overlayCur = overlay.token(stream, state.overlay);
          state.overlayPos = stream.pos;
        } else {
          // No overlay tokenisation, so just skip to the end.
          state.overlayPos = stream.string.length;
        }
      }

      if (state.overlayCur !== null) {
        // If the overlay has labelled the stream, skip over it in the base stream.
        stream.pos = state.overlayPos;
      } else {
        // If the overlay hasn't labelled the stream, process it in the base stream.
        if (stream.start === state.basePos) {
          stream.pos = stream.start;
          state.baseCur = base.token(stream, state.base);
          state.basePos = stream.pos;
        }

        stream.pos = Math.min(state.basePos, state.overlayPos);
      }

      var token = state.overlayCur === null ? state.baseCur : state.overlayCur;

      if (typeof overlay.filter === "function") {
        token = overlay.filter(stream, state.overlay, token);
      }

      return token;
    },

    indent:
      base.indent &&
      function(state, textAfter) {
        return base.indent(state.base, textAfter);
      },

    electricChars: base.electricChars,

    innerMode: function(state) {
      return {
        state: state.base,
        mode: base,
      };
    },

    blankLine: function(state) {
      if (base.blankLine) base.blankLine(state.base);
      if (overlay.blankLine) overlay.blankLine(state.overlay);
    },
  };
};
